export default {
  evaluation_list: {
    title: 'Danh sách nhà cung cấp',
    number_of_companies_answered: 'Đã gửi: {answered}/{total} Các công ty',
    number_of_companies_displayed: 'Hiển thị {start}〜{end} / {total} công ty',
    company_name: 'Tên Công ty',
    status: 'Trạng thái',
    questionnaire: 'Phiếu câu hỏi',
    plan: 'Kế hoạch',
    nothing: 'Không tìm thấy kết quả nào',
  },
  evidence_options: {
    all_plan: 'Tất cả kế hoạch',
    plans_with_vouchers: 'Có dẫn chứng',
    no_voucher_plan: 'Không có dẫn chứng',
  },
  table_headers: {
    company_name: 'Tên công ty',
    status: 'Trạng thái',
    esg_rating: 'Xếp hạng ESG',
    esg_score: 'Điểm ESG',
    environment: 'Môi trường',
    social: 'Xã hội',
    governance: 'Quản trị',
    plan: 'Kế hoạch',
    questionnaire: 'Phiếu câu hỏi',
    answer_date: 'Ngày gửi',
    answer_expires_date: 'Hạn cuối',
  },
  plan_list: {
    light: 'Kế hoạch về ánh sáng',
    starter: 'Kế hoạch khởi đầu',
    basic: 'Kế hoạch cơ bản',
    standard: 'Kế hoạch tiêu chuẩn',
    enterprize: 'Kế hoạch cho doanh nghiệp',
  },
}
